const NUMBER_OF_ELEMENT_TO_DISPLAY_PER_PAGE = 5;

/**
 * Handle pagination
 *
 * @param pageEleArr
 * @param numOfEleToDisplayPerPage
 */
export function pagination(
	pageEleArr,
	numOfEleToDisplayPerPage = NUMBER_OF_ELEMENT_TO_DISPLAY_PER_PAGE
) {
	// Create an object to easily manipulate property linked
	const result = {};

	// Added a new property to hold the list of elements
	result.pageEleArr = pageEleArr;

	// Added a new property to hold the number of item to display per page
	result.numOfEleToDisplayPerPage = numOfEleToDisplayPerPage;

	// Added a new property to hold the total number of items
	result.elementCount = result.pageEleArr.length;

	// Added a new property to hold the number of items to display per page
	result.numOfPages = Math.ceil(result.elementCount / result.numOfEleToDisplayPerPage);

	/*const MAX_NUMBER_OF_PAGINATION = 10;

	if (result.numOfPages > MAX_NUMBER_OF_PAGINATION) {
		result.numOfEleToDisplayPerPage = Math.ceil(result.elementCount / 20);

		result.numOfPages = Math.ceil(result.elementCount / result.numOfEleToDisplayPerPage);
	}*/

	// Set the current page number to 1
	result.currentPageNumber = 1;

	result.listOfPageNumber = function () {
		const listOfPageNumber = [];
		for (let i = 1; i < result.numOfPages + 1; i++) {
			listOfPageNumber.push(i);
		}
		return listOfPageNumber;
	};

	// Function to get the various list item per page
	// Return Array[Array]
	const pageElementsArr = function (arr, eleDispCount) {
		const arrLen = arr.length;
		const noOfPages = Math.ceil(arrLen / eleDispCount);
		const pageArr = [];

		let perPageArr = [], index = 0, condition = 0, remainingEleInArr = 0;

		for (let i = 0; i < noOfPages; i++) {
			if (i === 0) {
				index = 0;
				condition = eleDispCount;
			}
			// Create an list of items of a page
			for (let j = index; j < condition && j < arrLen; j++) {
				perPageArr.push(arr[j]);
			}

			// insert that list into then global list
			pageArr.push(perPageArr);

			if (i === 0) {
				remainingEleInArr = arrLen - perPageArr.length;
			} else {
				remainingEleInArr = remainingEleInArr - perPageArr.length;
			}

			if (remainingEleInArr > 0) {
				if (remainingEleInArr > eleDispCount) {
					index = index + eleDispCount;
					condition = condition + eleDispCount;
				} else {
					index = index + perPageArr.length;
					condition = condition + remainingEleInArr;
				}
			}
			perPageArr = [];
		}
		return pageArr;
	};

	// Main method to get a list of a particular page
  	result.display = function (pageNo) {
		// If the asked page is not in the range of available pages
		if (pageNo > result.numOfPages || pageNo <= 0) {
			return [];
		} else {
			// Get the total list
			const totalList = pageElementsArr(result.pageEleArr, result.numOfEleToDisplayPerPage);

			// Return the list of the pageNo
			return totalList[[pageNo - 1]];
		}
	};

	// Return the pagination object
	return result;
}


/**
 * Switch between page
 *
 * @param action
 * @param paginationObject result of pagination function execution
 */
export function handlePaginationClick(action, paginationObject) {
	// If we want to go to the previous page
	if (action === 'prev') {
		if (paginationObject.currentPageNumber - 1 >= 1)
			paginationObject.currentPageNumber = paginationObject.currentPageNumber - 1;
	}

	// If we want to go to the next page
	else if (action === 'next') {
		if (paginationObject.currentPageNumber + 1 <= paginationObject.numOfPages)
			paginationObject.currentPageNumber = paginationObject.currentPageNumber + 1;
	}

	// If we want to go to a particular page
	else {
		const numberOfPageToGoTo = Number(action);
		if (numberOfPageToGoTo <= paginationObject.numOfPages &&
			numberOfPageToGoTo >= 1
		) paginationObject.currentPageNumber = numberOfPageToGoTo;
	}

	return paginationObject;
}

export const paginationDataProperty = (i18n) => {
	return {
		filterCriteria: '',
		currentPatientArray: [],
		currentPatientArrayFiltered: [],
		currentAssociationArray: [],
		currentAssociationArrayFiltered: [],
		paginationObject: {},

		sortDirection: 'asc',
		sortSelected: null,

		/*sortOptions: [
			{ value: null, text: `${i18n.t('message.sortBy')}...`, disabled: true },
			{ value: 'nom', text: i18n.tc('message.patients', 1) },
			{ value: 'dossier', text: i18n.t('message.fileNumber') },
			{ value: 'age', text: i18n.t('message.old') },
			{ value: 'email', text: i18n.t('message.email') },
		],*/
	}
};
